<template>
    <el-dialog
        :visible="visible"
        :modal-append-to-body="true"
        class="ah-detail-dialog accounting-voucher-list-voucher-detail"
        top="2vh"
        append-to-body
        :before-close="onBeforeClose"
        :lock-scroll="false"
        @open="onOpen"
    >
        <template slot="title">傳票</template>
        <div class="container">
            <div v-if="!vono && !isEdited" style="padding: 10px 0">
                <el-radio-group v-model="voucherType" @change="updateData">
                    <el-radio-button v-if="isAuth('G06') && !isQR()" :label="0">空白傳票</el-radio-button>
                    <el-tooltip class="item" effect="dark" content="沒有權限：「傳票作業：自編轉帳傳票」" placement="top">
                        <el-radio-button v-if="!isAuth('G06')" :label="2" disabled>空白傳票</el-radio-button>
                    </el-tooltip>
                    <el-radio-button v-if="isAuth('G11') && !isQR()" :label="2">調整傳票</el-radio-button>
                    <el-tooltip class="item" effect="dark" content="沒有權限：「傳票作業：自編調整傳票」" placement="top">
                        <el-radio-button v-if="!isAuth('G11')" :label="2" disabled>調整傳票</el-radio-button>
                    </el-tooltip>
                    <el-radio-button v-if="isAuth('G12') && !isQR()" :label="1">開帳傳票</el-radio-button>
                    <el-tooltip class="item" effect="dark" content="沒有權限：「傳票作業：開帳傳票」" placement="top">
                        <el-radio-button v-if="!isAuth('G12')" :label="1" disabled>開帳傳票</el-radio-button>
                    </el-tooltip>
                </el-radio-group>
            </div>
            <el-button v-else @click="onPrint">列印傳票</el-button>
        </div>
        <div v-loading="isLoading">
            <VoucherCard
                ref="VoucherCard"
                :queryType="voucherData.transactionType"
                :accountTypeSno="voucherData.sno"
                :voucherData="voucherData"
                editable
                :addEmptyVoucherMode="!vono"
                is-dialog
                :is-open="!!voucherType"
                @edit="onEditVoucher"
                @cancel="onCancelVoucher"
                @submit="onEdited"
                @delete="onDelete"
                @void="onEdited"
                @cancelVoid="onEdited"
                @approve="onEdited"
                @cancelApprove="onEdited"
                @duplicate="onDuplicate"
            />
        </div>
        <div class="right">
            <el-button v-if="showOpenDetailBtn" @click="onOpenDetail" icon="el-icon-document">檢視來源帳務與相關傳票</el-button>
            <el-button v-if="!vono && isEdited && !isQR()" @click="onOpen" icon="el-icon-document">新增下一張空白傳票</el-button>
        </div>
        <AccountingDetailDialog :visible="detailDialog.visible" :QueryType="detailDialog.QueryType" :sno="detailDialog.sno" @update="updateData" @close="onDetailDialogClose"></AccountingDetailDialog>
    </el-dialog>
</template>

<script>
import VoucherCard from '@/components/dashboard/Accounting/AccountingSummary/ui/VoucherCard.vue';
import AccountingDetailDialog from '@/components/dashboard/Accounting/AccountingSummary/AccountingDetailDialog.vue';

export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        sno: {
            type: [Number, Object],
            default: null,
        },
        vono: {
            type: String,
            default: null,
        },
    },
    components: { VoucherCard, AccountingDetailDialog },
    data() {
        return {
            isLoading: false,
            voucherData: {
                accountItems: [],
                dat: null,
                cnl: false,
                cny: 'TWD',
                mem: null,
                sno: null,
                unT_NBR: null,
                unt: null,
                upD_USR: null,
                vono: null,
                voucherType: null,
                isEditing: false,
            },

            isEdited: false,
            isEditing: false,
            detailDialog: {
                visible: false,
                QueryType: null,
                sno: null,
            },
            voucherType: 0,
        };
    },
    computed: {
        showOpenDetailBtn() {
            return this.voucherData.transactionType && this.voucherData.transactionType !== 11 && this.voucherData.transactionType !== 12 && this.voucherData.transactionType !== 13;
        },
        submitVoucherType() {
            switch (this.voucherType) {
            case 1:
                return 91;
            case 2:
                return 12;
            default:
                return 10;
            }
        },
    },
    methods: {
        onOpen() {
            this.isEdited = false;
            this.voucherType = 0;
            this.updateData();
        },
        emptyVoucherData() {
            this.voucherData = {
                accountItems: [],
                dat: null,
                cnl: false,
                cny: 'TWD',
                mem: null,
                sno: null,
                unT_NBR: '',
                unt: null,
                upD_USR: null,
                vono: null,
                voucherType: this.submitVoucherType,
                isEditing: false,
            };
        },
        applyItems(items) {
            this.$refs.VoucherCard.addVoucherItems(items);
        },
        updateData() {
            if (this.vono) this.getVoucher();
            else {
                this.emptyVoucherData();
                this.$nextTick(() => {
                    this.$refs.VoucherCard.updateFormData();
                    this.$refs.VoucherCard.activeEdit();
                });
            }
        },
        async getVoucher() {
            this.isLoading = true;
            try {
                const resp = await this.$api({
                    url: '/AccountingSummaryPage/GetVoucher',
                    params: { vono: this.vono },
                    method: 'GET',
                });

                this.voucherData = resp.data.item;
                this.$nextTick(() => {
                    this.$refs.VoucherCard.updateFormData();
                });
            } finally {
                this.isLoading = false;
            }
        },
        async onCancelVoucher(voucher) {
            this.isEditing = false;
            // 新增傳票未儲存就按取消，關閉跳窗
            if (!voucher.sno) {
                this.$emit('close');
            }
        },

        async onBeforeClose() {
            try {
                if (this.isEditing) {
                    await this.$confirm('傳票尚在編輯中，確定要關閉嗎？', {
                        confirmButtonText: '確定',
                        cancelButtonText: '取消',
                    });
                }

                this.$refs.VoucherCard.cancelEdit();
                this.$emit('close', this.isEdited);
            } catch (e) {
                console.log(e);
            }
        },
        onDelete() {
            this.$emit('close', true);
        },
        onEdited() {
            this.isEdited = true;
            this.isEditing = false;
            if (this.vono) this.getVoucher();
        },
        onOpenDetail() {
            let sno;

            switch (this.voucherData.transactionType) {
            case 7: // Salary
                sno = {
                    year: this.voucherData.unT_NBR.substring(0, 4),
                    month: `${+this.voucherData.unT_NBR.substring(4)}`,
                };
                break;
            case 8: // Loan
                if (this.voucherData.unt === 'LoanReceiptRepayment') {
                    sno = { repaymentSno: this.voucherData.unT_NBR_SNO };
                } else {
                    sno = { drawdownSno: this.voucherData.unT_NBR_SNO };
                }
                break;
            default:
                sno = this.voucherData.unT_NBR_SNO;
                break;
            }

            this.detailDialog.QueryType = this.voucherData.transactionType;
            this.detailDialog.sno = sno;
            this.detailDialog.visible = true;
            this.onBeforeClose();
        },
        onDetailDialogClose(refresh) {
            this.detailDialog.visible = false;
            this.detailDialog.sno = null;
            if (refresh) {
                this.isEdited = true;
                this.onBeforeClose();
            }
        },
        onPrint() {
            this.$router.push({ name: 'accounting-voucher-print', params: { vono: this.vono } });
        },
        onDuplicate() {
            this.$emit('duplicate', this.voucherData);
        },

        onEditVoucher() {
            this.isEditing = true;
        },
    },
};
</script>

<style lang="scss">
.accounting-voucher-list-voucher-detail {
    &.ah-detail-dialog .el-dialog .el-dialog__body {
        padding: 10px 0;
        background-color: #f4f4f6;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
    }
    .container {
        padding: 0 20px;
    }
    .right {
        text-align: right;
        margin: 0 20px 20px;
    }
}
</style>
